var objectProto = Object.prototype;

var isPrototype = function isPrototype(value) {
  var Ctor = value && value.constructor;
  var proto = typeof Ctor === 'function' && Ctor.prototype || objectProto;
  return value === proto;
};

module.exports = isPrototype;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-prototype.js
// module id = 114
// module chunks = 0 1 2